import { z } from 'zod';
import * as contact from '../../primitives/contact';
import * as identity from '../../primitives/identity';
import { RequiredMessage } from '../../validation/messages';

export const contactBlock = z.object({
  countryCallingCodeId: z.string().min(1, RequiredMessage),
  phone: contact.phone.schema.min(1, RequiredMessage),
  email: identity.email.schema,
});

export const contactBlockOptional = contactBlock.partial();

export type ContactBlock = z.infer<typeof contactBlock>;
